import React from "react";

import Card from "./Card";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function TextCard(props) {
    const {
        title = "",
        items = [],
        background_color = ""
    } = props;
    return (
        <Section className={style.ticketPage}>
            <div className={style.ticketPageHeader}>
                {
                    title !== "" && (
                        <div className={style.ticketTitle}>
                            <Title transform="uppercase" tag="h1" className="fontTeko">{title}</Title>
                            <Spacer size="24" />
                        </div>
                    )
                }
                {
                    items.length > 0 && (
                        <div className={style.ticketRow}>
                            {
                                items.map((item, index) => (
                                    <Card
                                        size="col4"
                                        item={item}
                                        key={`ticket_grid_${index}`}
                                        backgroundColor={background_color}
                                    />
                                ))
                            }
                        </div>
                    )
                }
            </div>
        </Section>
    )
}